import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

function NewsTicker({ refreshKey }) {
  const [headlines, setHeadlines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchNews() {
      try {
        const res = await apiFetch('/api/news');
        if (res.ok) setHeadlines(await res.json());
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchNews();
  }, [refreshKey]);

  if (loading) return <section className="card"><h2>News</h2><p className="loading">Loading...</p></section>;

  return (
    <section className="card news-section">
      <h2>News</h2>
      <div className="news-list">
        {headlines.map((item, i) => (
          <div key={i} className="news-item">
            <span className="news-title">{item.title}</span>
            {item.source && <span className="news-source">{item.source}</span>}
          </div>
        ))}
      </div>
    </section>
  );
}

export default NewsTicker;
